"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInformationContainer = exports.MenuItemType = void 0;
var React = __importStar(require("react"));
var uuid_1 = require("uuid");
var classnames_1 = __importDefault(require("classnames"));
var AvatarFace_1 = require("../AvatarFace/AvatarFace");
var Mana_1 = require("../Mana/Mana");
var Button_1 = require("../Button/Button");
var Column_1 = require("../Column/Column");
var ActivityIcon_1 = __importDefault(require("../Icons/ActivityIcon"));
var Wallet_1 = __importDefault(require("../Icons/Wallet"));
var LogoutIcon_1 = __importDefault(require("../Icons/LogoutIcon"));
var SettingsIcon_1 = __importDefault(require("../Icons/SettingsIcon"));
var GroupIcon_1 = __importDefault(require("../Icons/GroupIcon"));
var BookmarkedIcon_1 = __importDefault(require("../Icons/BookmarkedIcon"));
var config_1 = require("../../config");
var Notifications_1 = __importDefault(require("../Notifications/Notifications"));
require("./UserInformationContainer.css");
var MenuItemType;
(function (MenuItemType) {
    MenuItemType["ACTIVITY"] = "Activity";
    MenuItemType["MY_ASSETS"] = "My Assets";
    MenuItemType["SETTINGS"] = "Settings";
    MenuItemType["MY_LISTS"] = "My Lists";
    MenuItemType["ACCOUNT"] = "Account";
    MenuItemType["PROFILE"] = "Profile";
})(MenuItemType = exports.MenuItemType || (exports.MenuItemType = {}));
var UserInformationContainer = /** @class */ (function (_super) {
    __extends(UserInformationContainer, _super);
    function UserInformationContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            isClickable: false
        };
        _this.trackingId = null;
        _this.mounted = false;
        _this.handleClose = function () {
            _this.toggle(false);
        };
        _this.handleToggle = function () {
            if (!_this.state.isOpen) {
                _this.trackingId = (0, uuid_1.v4)();
                if (_this.props.onOpen) {
                    _this.props.onOpen(_this.trackingId);
                }
            }
            _this.toggle(!_this.state.isOpen);
        };
        _this.renderManaBalances = function () {
            var _a = _this.props, manaBalances = _a.manaBalances, onClickBalance = _a.onClickBalance;
            return (React.createElement("div", { className: "dcl new-account-wrapper" }, Object.keys(manaBalances).map(function (network) { return (React.createElement(Mana_1.Mana, { key: network, network: network, size: "small", className: onClickBalance ? 'clickable' : undefined, onClick: function () {
                    if (onClickBalance) {
                        onClickBalance(network);
                    }
                    // Waits for any possible tracking to finish
                    setTimeout(function () {
                        window.open(config_1.config.get('ACCOUNT_URL'), '_blank', 'noopener');
                    }, onClickBalance ? 300 : 0);
                }, title: "".concat(manaBalances[network].toLocaleString(), " MANA") }, Number(manaBalances[network].toFixed(2)).toLocaleString())); })));
        };
        _this.handleClickActivity = function () {
            var _a = _this.props, onClickActivity = _a.onClickActivity, onMenuItemClick = _a.onMenuItemClick;
            if (onMenuItemClick) {
                onMenuItemClick(MenuItemType.ACTIVITY, _this.trackingId);
            }
            setTimeout(function () {
                onClickActivity
                    ? onClickActivity()
                    : window.open("".concat(config_1.config.get('MARKETPLACE_URL'), "/activity"), '_blank', 'noopener');
            }, onClickActivity ? 300 : 0);
        };
        _this.handleClickMyAssets = function () {
            var _a = _this.props, onClickMyAssets = _a.onClickMyAssets, onMenuItemClick = _a.onMenuItemClick;
            if (onMenuItemClick) {
                onMenuItemClick(MenuItemType.MY_ASSETS, _this.trackingId);
            }
            setTimeout(function () {
                onClickMyAssets
                    ? onClickMyAssets()
                    : window.open("".concat(config_1.config.get('MARKETPLACE_URL'), "/account?section=collections"), '_blank', 'noopener');
            }, onMenuItemClick ? 300 : 0);
        };
        _this.handleClickSettings = function () {
            var _a = _this.props, onClickSettings = _a.onClickSettings, onMenuItemClick = _a.onMenuItemClick;
            if (onMenuItemClick) {
                onMenuItemClick(MenuItemType.SETTINGS, _this.trackingId);
            }
            setTimeout(function () {
                onClickSettings
                    ? onClickSettings()
                    : window.open("".concat(config_1.config.get('MARKETPLACE_URL'), "/settings"), '_blank', 'noopener');
            }, onMenuItemClick ? 300 : 0);
        };
        _this.handleClickMyLists = function () {
            var _a = _this.props, onClickMyLists = _a.onClickMyLists, onMenuItemClick = _a.onMenuItemClick;
            if (onMenuItemClick) {
                onMenuItemClick(MenuItemType.MY_LISTS, _this.trackingId);
            }
            setTimeout(function () {
                onClickMyLists
                    ? onClickMyLists()
                    : window.open("".concat(config_1.config.get('MARKETPLACE_URL'), "/lists"), '_blank', 'noopener');
            }, onMenuItemClick ? 300 : 0);
        };
        _this.handleClickAccount = function () {
            var _a = _this.props, onClickAccount = _a.onClickAccount, onMenuItemClick = _a.onMenuItemClick;
            if (onMenuItemClick) {
                onMenuItemClick(MenuItemType.ACCOUNT, _this.trackingId);
            }
            setTimeout(function () {
                onClickAccount
                    ? onClickAccount()
                    : window.open(config_1.config.get('ACCOUNT_URL'), '_blank', 'noopener');
            }, onMenuItemClick ? 300 : 0);
        };
        _this.handleClickProfile = function () {
            var _a = _this.props, onClickProfile = _a.onClickProfile, onMenuItemClick = _a.onMenuItemClick;
            if (onMenuItemClick) {
                onMenuItemClick(MenuItemType.PROFILE, _this.trackingId);
            }
            setTimeout(function () {
                onClickProfile
                    ? onClickProfile()
                    : window.open(config_1.config.get('PROFILE_URL'), '_blank', 'noopener');
            }, onMenuItemClick ? 300 : 0);
        };
        _this.handleSignOut = function () {
            var onSignOut = _this.props.onSignOut;
            onSignOut(_this.trackingId);
        };
        _this.getAvatarName = function () {
            var _a = _this.props, avatar = _a.avatar, address = _a.address, sliceAddressBy = _a.sliceAddressBy;
            var sliceLimit = Math.max(Math.min(sliceAddressBy, 42), 6);
            if (!avatar || !avatar.name) {
                return address.slice(0, sliceLimit);
            }
            if (avatar.hasClaimedName) {
                return avatar.name;
            }
            var userId = address || avatar.userId;
            var lastPart = userId ? "#".concat(userId.slice(-4)) : '';
            return avatar.name.endsWith(lastPart) ? avatar.name : avatar.name + lastPart;
        };
        return _this;
    }
    UserInformationContainer.prototype.toggle = function (value) {
        var _this = this;
        this.setState({ isOpen: value });
        setTimeout(function () {
            if (_this.mounted) {
                _this.setState({ isClickable: value });
            }
        }, 250);
    };
    UserInformationContainer.prototype.componentDidMount = function () {
        this.mounted = true;
    };
    UserInformationContainer.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    UserInformationContainer.prototype.render = function () {
        var _a = this.props, avatar = _a.avatar, isSignedIn = _a.isSignedIn, isSigningIn = _a.isSigningIn, onSignIn = _a.onSignIn, onClickProfile = _a.onClickProfile, i18n = _a.i18n, hasActivity = _a.hasActivity, notifications = _a.notifications;
        var _b = this.state, isOpen = _b.isOpen, isClickable = _b.isClickable;
        var name = avatar ? this.getAvatarName() : null;
        return (React.createElement(Column_1.Column, { align: "right" }, !isSignedIn ? (React.createElement(Button_1.Button, { primary: true, disabled: isSigningIn, onClick: onSignIn, className: "navbar-sign-in" }, i18n.signIn)) : (React.createElement("div", { className: "dcl new-user-menu", onBlur: this.handleClose, tabIndex: 0 },
            notifications && React.createElement(Notifications_1.default, __assign({}, notifications)),
            React.createElement(Button_1.Button, { basic: true, onClick: this.handleClickActivity, className: "activity-icon" },
                React.createElement(ActivityIcon_1.default, { hasActivity: hasActivity })),
            this.renderManaBalances(),
            React.createElement("div", { className: "toggle", onClick: this.handleToggle },
                React.createElement(AvatarFace_1.AvatarFace, { size: "medium", avatar: avatar })),
            React.createElement("div", { className: (0, classnames_1.default)('menu', isOpen && 'open', isClickable && 'clickable') },
                React.createElement("div", { className: "info ".concat(onClickProfile ? 'clickable' : ''), onClick: this.handleClickProfile },
                    React.createElement("div", { className: "image" },
                        React.createElement(AvatarFace_1.AvatarFace, { size: "small", avatar: avatar })),
                    React.createElement("div", null,
                        React.createElement("div", { className: "name" }, name !== null && name !== void 0 ? name : i18n.guest))),
                React.createElement(Button_1.Button, { className: "view-profile", inverted: true, onClick: this.handleClickProfile }, i18n.profile),
                React.createElement("ul", { className: "actions" },
                    React.createElement("div", { onClick: this.handleClickAccount },
                        React.createElement("li", { className: "menu-option" },
                            React.createElement(Wallet_1.default, null),
                            "\u00A0",
                            i18n.wallet)),
                    React.createElement("div", { onClick: this.handleClickMyAssets },
                        React.createElement("li", { className: "menu-option" },
                            React.createElement(GroupIcon_1.default, null),
                            " \u00A0",
                            i18n.myAssets)),
                    React.createElement("div", { onClick: this.handleClickMyLists },
                        React.createElement("li", { className: "menu-option" },
                            React.createElement(BookmarkedIcon_1.default, null),
                            " \u00A0",
                            i18n.myLists)),
                    React.createElement("div", { onClick: this.handleClickSettings },
                        React.createElement("li", { className: "menu-option" },
                            React.createElement(SettingsIcon_1.default, null),
                            " \u00A0",
                            i18n.settings)),
                    React.createElement("li", { onClick: this.handleSignOut, className: "menu-option" },
                        React.createElement(LogoutIcon_1.default, null),
                        " \u00A0",
                        i18n.signOut)))))));
    };
    UserInformationContainer.defaultProps = {
        manaBalances: {},
        i18n: {
            signIn: 'Sign In',
            guest: 'Guest',
            profile: 'View My Profile',
            wallet: 'Wallet',
            myAssets: 'My Assets',
            myLists: 'My Lists',
            settings: 'Account Settings',
            signOut: 'Log Out'
        }
    };
    return UserInformationContainer;
}(React.Component));
exports.UserInformationContainer = UserInformationContainer;
